module.exports = __webpack_public_path__ + "img/bg.1520d218.svg";